import { LazyModule } from 'owa-bundling';
// Import orchestrators and mutators so they get registered

import './orchestrators/initTableSelectionOnLoadOrchestrator';
import './orchestrators/keyboardMultiSelectRowOrchestrator';
import './orchestrators/rangeSelectRowOrchestrator';
import './orchestrators/resetSelectionOrchestrator';
import './orchestrators/selectNewItemUponRowRemovalOrchestrator';
import './orchestrators/selectRowInDirectionOrchestrator';
import './orchestrators/singleSelectRowOrchestrator';
import './orchestrators/toggleSelectAllRowsOrchestrator';
import './orchestrators/toggleSelectRowOrchestrator';

import './mutators/resetSelectionOnTableMutator';
import './mutators/setSelectionOnRowMutator';

export const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ExpandedListSelectionActions" */ './lazyIndex')
);
